import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { CustomerModel } from '../models/customer.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { first, finalize, last, map } from 'rxjs/operators';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { Md5 } from 'ts-md5';
import { Observable, timer } from 'rxjs';
import { AngularFireStorage } from 'angularfire2/storage';
import { PromoModel } from '../models/promo.model';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/fire/database";
import * as i3 from "@angular/fire/auth";
import * as i4 from "@angular/fire/storage";
var CustomerService = /** @class */ (function () {
    function CustomerService(http, db, afAuth, storage) {
        this.http = http;
        this.db = db;
        this.afAuth = afAuth;
        this.storage = storage;
        this.api = environment.apiURL;
    }
    /**
     * Get current customer
     * @param force - force user update
     * @returns {Promise<CustomerModel>} return response as Promise
     */
    CustomerService.prototype.getCurrentCustomer = function (force) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.customer && !force)
                resolve(_this.customer);
            else {
                _this.getCurrentUser()
                    .then(function (user) {
                    if (user && user['uid']) {
                        _this.db.object('/users/' + user['uid']).valueChanges()
                            .pipe(first())
                            .toPromise()
                            .then(function (data) {
                            if (data['role'] == 'customer') {
                                var customer = data;
                                customer['uid'] = user['uid'];
                                _this.customer = new CustomerModel(customer);
                                resolve(_this.customer);
                            }
                            else {
                                reject({
                                    errorCode: 70,
                                    errorMessage: 'Current user is registered as driver'
                                });
                            }
                        })
                            .catch(function (err) {
                            reject({
                                errorCode: 50,
                                errorMessage: 'Profile load error.'
                            });
                        });
                    }
                    else {
                        resolve(null);
                    }
                })
                    .catch(reject);
            }
        });
    };
    /**
     * Get current customer promo
     * @returns {Promise<any>} - return data as promise
     */
    CustomerService.prototype.getCustomerPromos = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getCurrentCustomer()
                .then(function (customer) {
                return _this.db.object('/promos/' + customer.uid).valueChanges()
                    .subscribe(function (promos) {
                    var promosArray = [];
                    var firstTime = promos['firstTimeReferredBy'] || {};
                    var referralPromo = promos['referrals'] || {};
                    _.forEach(firstTime, function (promo, key) {
                        promosArray.push(new PromoModel({
                            id: key,
                            type: 'firstTimeReferredBy',
                            expires: promo.expires,
                            status: promo.status && !promos['isFirstTimeUsed']
                        }));
                    });
                    _.forEach(referralPromo, function (promo, key) {
                        promosArray.push(new PromoModel({ id: key, type: 'referrals', expires: promo.expires, status: !promo.isUsed }));
                    });
                    promosArray = _.orderBy(promosArray, ['expires'], ['asc']);
                    return subscriber.next(promosArray);
                });
            });
        });
    };
    /**
   * Get current customer promo
   * @returns {Promise<any>} - return data as promise
   */
    CustomerService.prototype.isGiveawayWinner = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getCurrentCustomer(true)
                .then(function (customer) {
                if (customer.giveaway === true)
                    resolve(customer.giveaway);
                else
                    reject(customer.giveaway);
            });
        });
    };
    /**
     * Get customer by phone number
     * @param {string} phone - phone number
     * @returns {Promise<Object>} return response as promise
     */
    CustomerService.prototype.getCustomerByPhone = function (phone) {
        return this.http.get(this.api + '/users/byPhone/' + phone)
            .pipe(map(function (res) {
            if (res['uid'])
                return new CustomerModel(res);
            else
                return null;
        }))
            .toPromise();
    };
    /**
     * Sign out user
     * @returns {Promise<any>} return response as promise
     */
    CustomerService.prototype.signOut = function () {
        return this.afAuth.auth.signOut();
    };
    /**
     * Send sms verification with code
     * @param {string} countryCode - country code
     * @param {string} number - phone number
     * @returns {Promise<any>} return response as promise
     */
    CustomerService.prototype.sendSms = function (countryCode, number) {
        return this.http.post(this.api + '/users/smsVerification', { countryCode: countryCode, number: number })
            .toPromise();
    };
    /**
     * Verify code sent by sms and return user token for auth
     * @param {string} countryCode - country code
     * @param {string} number - phone number
     * @param {string} code - code received by sms
     * @returns {Promise<any>} return response as promise
     */
    CustomerService.prototype.smsCodeVerification = function (countryCode, number, code) {
        return this.http.post(this.api + '/users/phoneVerification', {
            countryCode: countryCode,
            number: number,
            code: code,
            isCustomer: true
        }).toPromise();
    };
    /**
     * Sign in with custom token
     * @param {string} token - token
     * @returns {Promise<CustomerModel>} return data as promise
     */
    CustomerService.prototype.signInWithToken = function (token) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.afAuth.auth.signInWithCustomToken(token)
                .then(function (res) {
                console.log(res);
                if (res.user && res.user.uid) {
                    _this.db.object('/users/' + res.user.uid).valueChanges()
                        .pipe(first())
                        .toPromise()
                        .then(function (data) {
                        if (data['role'] != 'customer') {
                            reject({
                                errorCode: 70,
                                errorMessage: 'This phone number is already registered as a driver. Please contact support.'
                            });
                        }
                        else {
                            var customer = data;
                            customer['uid'] = res.user.uid;
                            _this.customer = new CustomerModel(customer);
                            resolve(_this.customer);
                        }
                    });
                }
                else {
                    reject({ errorCode: 60, errorMessage: 'Auth error' });
                }
            })
                .catch(function (err) {
                reject({ errorCode: 50, errorMessage: 'Internal server error' });
            });
        });
    };
    /**
     * Update customer profile
     * @param updates - data to update
     * @returns {Promise<any>} return response as promise
     */
    CustomerService.prototype.updateCustomerProfile = function (updates) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (updates['password'])
                updates['password'] = Md5.hashStr(updates['password']);
            _this.getCurrentCustomer()
                .then(function (customer) {
                if (customer.uid) {
                    return _this.db.object('users/' + customer.uid).update(updates);
                }
                else
                    return reject({ errorMessage: 'Unexpected error. Please try again' });
            })
                .then(function (_) {
                resolve(true);
            })
                .catch(reject);
        });
    };
    /**
     * When auth state changed
     * @returns {Observable<CustomerModel>} return current customer as observable
     */
    CustomerService.prototype.authChanged = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            firebase.auth().onAuthStateChanged(function (auth) {
                if (auth) {
                    _this.getCurrentCustomer()
                        .then(function (res) {
                        subscriber.next(_this.customer);
                    })
                        .catch(function (err) {
                        subscriber.next(_this.customer);
                    });
                }
                else {
                    subscriber.next(null);
                }
            });
        });
    };
    /**
     * Create stripe account for current customer
     * @returns {Promise<any>} return response as promise
     */
    CustomerService.prototype.createStripeAccountForCurrentCustomer = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getCurrentCustomer()
                .then(function (customer) {
                if (customer.displayName && customer.email) {
                    var data = { email: customer.email, name: customer.displayName };
                    return _this.http.post(_this.api + '/stripe/customer', data).pipe(first()).toPromise();
                }
                else {
                    return Promise.reject({ errorMessage: 'User profile data missing' });
                }
            })
                .then(function (stripeCustomer) {
                return _this.updateCustomerProfile({ stpID: stripeCustomer['id'] });
            })
                .then(resolve)
                .catch(function (err) {
                var error = { errorMessage: err.errorMessage || 'Internal error' };
                reject(error);
            });
        });
    };
    /**
     * Get current user's stripe account information
     * @returns {Promise<any>} return response as promise
     */
    CustomerService.prototype.getStripeAccountInfo = function () {
        return this.http.get(this.api + '/stripe/customer', { headers: this.httpHeaders }).pipe(first()).toPromise();
    };
    /**
     * Add debit/credit card to current user's stripe account
     * @param {string} source - source id
     * @returns {Promise<any>} - return response as promise
     */
    CustomerService.prototype.addSourceToAccount = function (source) {
        return this.http.post(this.api + '/stripe/customer/source/' + source, {}, { headers: this.httpHeaders }).pipe(first()).toPromise();
    };
    /**
     * Create source
     * @param {string} source - source body (https://stripe.com/docs/api#create_source)
     * @returns {Promise<any>} - return response as Promise
     */
    CustomerService.prototype.createSource = function (source) {
        return this.http.post(this.api + '/stripe/customer/source/', source).pipe(first()).toPromise();
    };
    /**
     * Delete card from current user's stripe account
     * @param {string} cardId - card id
     * @returns {Promise<any>} - return response as promise
     */
    CustomerService.prototype.deleteCardFromAccount = function (cardId) {
        return this.http.delete(this.api + '/stripe/customer/source/' + cardId, { headers: this.httpHeaders }).pipe(first()).toPromise();
    };
    /**
     * Update current user's stripe account information
     * @param updates - for allowed arguments visit https://stripe.com/docs/api/node#update_customer
     * @returns {Promise<any>} return response as promise
     */
    CustomerService.prototype.updateStripeInformation = function (updates) {
        return this.http.put(this.api + '/stripe/customer', updates, { headers: this.httpHeaders }).pipe(first()).toPromise();
    };
    /**
     * Firebase implementation fo current user as promise
     * @returns {Promise<any>} return current user as promise
     */
    CustomerService.prototype.getCurrentUser = function (refreshToken) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var unsubscribe = _this.afAuth.auth.onAuthStateChanged(function (user) {
                if (user) {
                    user.getIdToken(!!refreshToken)
                        .then(function (token) {
                        if (!_this.checkingToken)
                            _this.tokenChecker(token);
                        _this.httpHeaders = new HttpHeaders({
                            'Authorization': 'Bearer ' + token
                        });
                    });
                }
                unsubscribe();
                resolve(user);
            }, reject);
        });
    };
    /**
     * Send text message with download link
     * @param countryCode - country code
     * @param phone - phone number
     * @returns {Promise<any>} - return response as promise
     */
    CustomerService.prototype.sendMeApp = function (countryCode, phone) {
        return this.http.post(this.api + '/users/downloadSms', { countryCode: countryCode, number: phone }).pipe(first()).toPromise();
    };
    /**
     * Send forgot password email with instructions
     * @param {string} uid - firebase user id
     * @returns {Promise<any>} - return response as promise
     */
    CustomerService.prototype.forgotPasswordRequest = function (uid) {
        return this.http.post(this.api + '/users/password/request', { uid: uid }).pipe(first()).toPromise();
    };
    /**
     * Claim promo code
     * @param data - data to pass
     * @returns {Promise<any>} - return response as promise
     */
    CustomerService.prototype.claimPromo = function (data) {
        return this.http.post(this.api + '/users/claimPromo', data).pipe(first()).toPromise();
    };
    /**
     * Generate promo code for current user
     * @returns {Promise<any>} - return data as promise
     */
    CustomerService.prototype.generatePromoCode = function () {
        return this.http.post(this.api + '/users/generatePromoCode', {}, { headers: this.httpHeaders }).pipe(first()).toPromise();
    };
    /**
     * Upload customer profile picture
     * @param {string} b64 - picture as base64 string
     * @returns {Promise<any>} - return download url
     */
    CustomerService.prototype.uploadProfilePicture = function (b64) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getCurrentCustomer()
                .then(function (customer) {
                if (customer) {
                    var customerId = customer.uid;
                    var ref_1 = _this.storage.ref('/users/' + customerId + '/picture.png');
                    var task = ref_1.putString(b64, 'data_url');
                    task.snapshotChanges().pipe(finalize(function () { return ref_1.getDownloadURL().pipe(first()).toPromise().then(resolve); })).pipe(last()).toPromise();
                }
                else {
                    return reject({ errorMessage: 'Customer not found' });
                }
            })
                .catch(function (err) {
                return reject(err);
            });
        });
    };
    /**
     * Change current customer phone number
     * @param code - code sent by text message
     * @param number - phone number
     * @returns {Promise<any>}
     */
    CustomerService.prototype.changePhone = function (code, number) {
        var data = { 'countryCode': '+1', 'code': code, 'number': number };
        return this.http.post(this.api + '/users/changePhone', data, { headers: this.httpHeaders }).pipe(first()).toPromise();
    };
    /**
     * Check expiration for user token
     * @param {string} token - token
     */
    CustomerService.prototype.tokenChecker = function (token) {
        var _this = this;
        this.checkingToken = true;
        try {
            var tokenData = JSON.parse(atob(token.split('.')[1]));
            var expiresIn = tokenData.exp * 1000 - new Date().getTime();
            if (expiresIn < 1000 * 60 * 10) {
                this.checkingToken = false;
                this.getCurrentUser(true);
            }
            else {
                //Check 5 minutes before expiration
                timer(expiresIn - 1000 * 60 * 5).pipe(first()).toPromise()
                    .then(function (_) {
                    _this.tokenChecker(token);
                });
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    CustomerService.ngInjectableDef = i0.defineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(i0.inject(i1.HttpClient), i0.inject(i2.AngularFireDatabase), i0.inject(i3.AngularFireAuth), i0.inject(i4.AngularFireStorage)); }, token: CustomerService, providedIn: "root" });
    return CustomerService;
}());
export { CustomerService };
